<ng-template #popContent class="license-pop-over">
  <aside role="alertdialog" aria-describedby="licensePopover">
    <button type="button" class="btn close btn btn-icon-close" aria-label="Close">
      <i class="fa fa-xmark fa-1 p-1" aria-hidden="true"></i>
    </button>
    <span id="licensePopover">
      Your subscription to {{license.description}} expires on {{license.expirationDate | date:'shortDate'}}.
      <br/>
      Renew your license to avoid losing access to this product.
    </span>
  </aside>
</ng-template>
<button id="license_alert_{{license?.name}}" class="text-primary pe-2 ps-2 btn-icon-exclamation" aria-label="License Expiration Notice" [container]="container" [placement]="placement" [triggers]="activationTrigger" [ngbPopover]="popContent" #popover="ngbPopover" (click)="open($event, popover); false" (document:click)="close($event, popover)">
  <i class="fa fa-circle-exclamation" aria-hidden="true"></i>
</button>
